import { useEffect } from 'react'

import { Form, Link } from '@domain-group/suit-theme'

import { pascalToSnakeCase, snakeToTitleCase } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'
import type { UseFormPayload } from '@domain-group/react-hooks'

import { filterNotificationsByLocation, findUniqueSectionTitles } from '@functions/notification'

const defaultState = {
  expanded: true,
  group: '',
  section: '',
  userType: 'agency',
}

interface LocationSelectorProps {
  notificationFormPayload: UseFormPayload,
}

const LocationSelector = (props: LocationSelectorProps) => {
  const { notificationFormPayload } = props

  const [state, setState] = useSetState(defaultState)
  const {
    expanded, group, section, userType,
  } = state

  const {
    entityState: { options },
    handlers,
    setEntityState,
  } = notificationFormPayload

  const { location, realhub_platform } = options || {}

  // @ts-expect-error TS2322
  const uniqueSectionTitles = findUniqueSectionTitles({ group, userType })
  // @ts-expect-error TS2322
  const filteredNotificationLocations = userType ? filterNotificationsByLocation({ group, section, userType }) : []

  // Clear location if any options change
  useEffect(() => {
    if (location) setEntityState({ options: { ...options, location: '' } })
  }, [group, section, userType])

  return (
    <>
      {expanded && (
        <Form.Field label="Page Location" marginTop="large">
          <select value={group} onChange={e => setState({ group: e.target.value })}>
            <option value="">Notification List (Default)</option>
            <option value="Banner">Banner</option>
            <option value="Sidebar">Sidebar</option>
          </select>
        </Form.Field>
      )}

      {!!group && (
        <Form.Field label="Realhub Platform" marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <select name="options.realhub_platform" value={realhub_platform} {...handlers}>
            <option value="">Legacy and Standalone</option>
            <option value="legacy">Legacy</option>
            <option value="standalone_v1">Standalone</option>
          </select>
        </Form.Field>
      )}

      {expanded && group && (
        <>
          <Form.Field label="User Type" marginTop="large">
            <select value={userType} onChange={e => setState({ userType: e.target.value })}>
              <option value="">Please Select...</option>
              <option value="admin">Admin</option>
              <option value="agency">Agency</option>
              <option value="brand">Brand</option>
              <option value="provider">Provider</option>
            </select>
          </Form.Field>

          <Form.Field label="Section" marginTop="large">
            <select value={section} onChange={e => setState({ section: e.target.value })}>
              <option value="">Please Select...</option>
              {uniqueSectionTitles.map(sectionTitle => (
                <option key={sectionTitle} value={sectionTitle}>
                  {snakeToTitleCase(pascalToSnakeCase(sectionTitle))}
                </option>
              ))}
            </select>
          </Form.Field>
        </>
      )}

      {!!group && (
        <Form.Field
          labelRight={!expanded && (
            <Link onClick={() => setState({ expanded: true })} textProps={{ fontSize: 'xsmall' }}>Change</Link>
          )}
          label={expanded ? '* Page' : '* Location'}
          marginTop="large"
        >
          <select
            disabled={!section || !userType}
            name="options.location"
            onChange={(e) => {
              setEntityState({ options: { ...options, location: e.target.value } })
              setState({ expanded: false })
            }}
            value={location}
          >
            <option value="">Please Select...</option>
            {filteredNotificationLocations.map((notificationLocation) => {
              const { id, title } = notificationLocation
              const page = title.split('/')[2]
              const optionText = expanded ? page : title.split('/').join(' / ')

              return (
                <option value={id}>
                  {snakeToTitleCase(pascalToSnakeCase(optionText))}
                </option>
              )
            })}
          </select>
        </Form.Field>
      )}
    </>
  )
}

export default LocationSelector
